export enum ProductUnitEnum {
  BALDE = 'Balde',
  BIDON = 'Bidon',
  BOLSA = 'Bolsa',
  CARGA = 'Carga',
  GALON_GAL = 'Galón (gal)',
  GRAMO_G = 'Gramo (g)',
  KILOGRAMO_KG = 'Kilogramo (kg)',
  LIBRA_LB = 'Libra (Ib)',
  LITRO = 'Litro (l)',
  MAZO = 'Mazo',
  METRO_M = 'Metro (m)',
  MILILITRO_ML = 'Mililitro (ml)',
  ONZAS_OZ = 'Onzas (oz)',
  PIE_FT = 'Pie (ft)',
  PULGADAS_IN = 'Pulgadas (in)',
  QUINTAL = 'Quintal',
  RACIMO = 'Racimo',
  ROLLOS = 'Rollos',
  UNIDAD_PIECE = 'Unidad (piece)',
}

export const getProductUnitDisplayNameWithTranslation = (
  unit: string,
  t: (key: string) => string
): string => {
  const isValidUnit = Object.values(ProductUnitEnum).includes(unit as ProductUnitEnum);
  return isValidUnit ? t(`form:measuringUnits.${unit}`) : unit;
};